import { Action } from "redux";
import { IAlarm, ILogEvent, ISite, IUser } from "types";

export const SITE_START_SYNCINGACTION = '@@site/SITE_START_SYNCINGACTION';
export const SITE_SELECT_ACTION = '@@site/SITE_SELECT_ACTION';
export const SITE_UPDATE_ACTION_START = '@@site/SITE_UPDATE_ACTION_START';
export const SITE_UPDATE_ACTION_FINISH = '@@site/SITE_UPDATE_ACTION_FINISH';
export const SITE_SYNC_ACTION_START = '@@site/SITE_SYNC_ACTION_START';
export const SITE_SAVE_ACTION_START = '@@site/SITE_SAVE_ACTION_START';
export const SITE_SYNC_ACTION_FINISH = '@@site/SITE_SYNC_ACTION_FINISH';
export const PUSH_SUBSCRIBE_FINISH = '@@site/PUSH_SUBSCRIBE_FINISH';
export const PUSH_UNSUBSCRIBE_FINISH = '@@site/PUSH_UNSUBSCRIBE_FINISH';
export const SITE_LIST_ACTION_FINISH = '@@site/SITE_LIST_ACTION_FINISH';
export const SITE_DELETE_ACTION_FINISH = '@@site/SITE_DELETE_ACTION_FINISH';
export const SITE_ADD_ACTION_START = '@@site/SITE_ADD_ACTION_START';
export const SITE_ADD_ACTION_FINISH = '@@site/SITE_ADD_ACTION_FINISH';
export const SITE_EDIT_NAVIGATE_ACTION = '@@site/SITE_EDIT_NAVIGATE_ACTION';
export const SITE_EDIT_ACTION_FINISH = '@@site/SITE_EDIT_ACTION_FINISH';
export const FIRMWARE_VERSION_ACTION_FINISH = '@@site/FIRMWARE_VERSION_ACTION_FINISH';
export const ALARM_LIST_ACTION_FINISH = '@@site/ALARM_LIST_ACTION_FINISH';
export const USER_LIST_ACTION_FINISH = '@@site/USER_LIST_ACTION_FINISH';
export const LOGEVENT_LIST_ACTION_FINISH = '@@site/LOGEVENT_LIST_ACTION_FINISH';
export const SITE_ADD_ERROR = '@@site/SITE_ADD_ERROR';
export const SITE_OUTPUT_CHANGE_START = '@@site/SITE_OUTPUT_CHANGE_START';
export const SITE_OUTPUT_CHANGED = '@@site/SITE_OUTPUT_CHANGED';
export const SITE_OUTPUT_ERROR_IN_CHANGE = '@@site/SITE_OUTPUT_ERROR_IN_CHANGE';
export const SITE_CHANNEL_SAVE = '@@site/SITE_CHANNEL_SAVE';
export const SITE_RECIPIENTS_SAVE = '@@site/SITE_RECIPIENTS_SAVE';
export const SITE_SCHEDULES_SAVE = '@@site/SITE_SCHEDULES_SAVE';
export const SITE_RECIPIENT_TEST_START = '@@site/SITE_RECIPIENT_TEST_START';
export const SITE_RECIPIENT_TEST_FINISH = '@@site/SITE_RECIPIENT_TEST_FINISH';
export const SITE_RECIPIENT_TEST_ERROR = '@@site/SITE_RECIPIENT_TEST_ERROR';
export const SITE_DASHBOARD_NAVIGATE_ACTION = '@@site/SITE_DASHBOARD_NAVIGATE_ACTION';
export const SITE_EDIT_TEMPERATURE_NAVIGATE_ACTION = '@@site/SITE_EDIT_TEMPERATURE_NAVIGATE_ACTION';
export const SITE_EDIT_THERMOSTAT_NAVIGATE_ACTION = '@@site/SITE_EDIT_THERMOSTAT_NAVIGATE_ACTION';
export const SITE_EDIT_INPUT_NAVIGATE_ACTION = '@@site/SITE_EDIT_INPUT_NAVIGATE_ACTION';
export const SITE_EDIT_OUTPUT_NAVIGATE_ACTION = '@@site/SITE_EDIT_OUTPUT_NAVIGATE_ACTION';
export const SITE_SESSION_EXPIRED = '@@site/SITE_SESSION_EXPIRED';
export const SITE_TIME_OUT = '@@site/SITE_TIME_OUT';
export const DEVICE_REGISTERED = '@@site/DEVICE_REGISTERED';
export const PUSH_DEVICES_OF_USER = '@@site/PUSH_DEVICES_OF_USER';
export const WORKING_START = '@@site/WORKING_START';
export const WORKING_STOP = '@@site/WORKING_STOP';
export const PUSH_TOKEN_SUCCESS = '@@site/PUSH_TOKEN_SUCCESS';



export interface IEmptyAction extends Action {
  type: string;
}

export interface ITokenAction extends Action {
  type: string;
  payload: {
    token: string;
  };
}



export interface ISiteSelectAction extends Action {
  type: string;
  payload?: {
    site: ISite;
    forceNavigateToDashboard: boolean;
  };
}


export interface IDashboardNavigateAction extends Action {
  type: string;
  payload: {};
}

export interface IEditTemperatureNavigateAction extends Action {
  type: string;
  payload: { no: number };
}


export interface ISiteEditNavigateAction extends Action {
  type: string;
  payload: { id: string, name: string };
}


export interface IPushAction extends Action {
  type: string;
  payload: { subscribed: boolean };
}

export interface IDeviceRegisteredAction extends Action {
  type: string;
  payload: { token: string };
}


export interface IEditOutputNavigateAction extends Action {
  type: string;
  payload: { no: number };
}

export interface ISiteSyncAction extends Action {
  type: string;
  payload: {
    errorMessage: string
  };
}

export interface ISiteListAction extends Action {
  type: string;
  payload?: {
    sites: ISite[]
  };
}

export interface IFirmwarVersionAction extends Action {
  type: string;
  payload?: {
    m1: string,
    m2: string,
  };
}

export interface ILogEventListAction extends Action {
  type: string;
  payload?: {
    logEvent: ILogEvent[],
    error: boolean,

  };
}

export interface IAlarmListAction extends Action {
  type: string;
  payload?: {
    alarm: IAlarm[];
  };
}

export interface IUserListAction extends Action {
  type: string;
  payload?: {
    user: IUser[];
  };
}

export interface ISiteDeleteAction extends Action {
  type: string;
  payload?: {
  };
}

export interface ISiteAddAction extends Action {
  type: string;
  payload?: {
    errorMessage: string
  };
}

export interface ISiteEditAction extends Action {
  type: string;
  payload?: {
  };
}

export interface ISiteUpdateAction extends Action {
  type: string;
  payload?: {
  };
}

export interface IOutputChangeStart extends Action {
  type: string;
  payload: {
    idOutput: number
  };
}

export interface IOutputChangedAction extends Action {
  type: string;
  payload: {
    idOutput: number,
    errorMessage: string
  };
}

export interface IChannelSaveAction extends Action {
  type: string;
  payload: {
    idChannel: number,
    errorMessage: string
  };
}

export interface IRecipientsSaveAction extends Action {
  type: string;
  payload: {
  };
}


export interface ISchedulesSaveAction extends Action {
  type: string;
  payload: {
  };
}

export interface IRecipientsTestAction extends Action {
  type: string;
  payload: {
    errorMessage: string
  };
}



// WEBPACK FOOTER //
// ./src/actions/SiteActionType.tsx